import React, { Component } from "react";
import TextInput from "../../inputs/TextInput";
import ExistingForms from "./ExistingForms";

class FormBuilderSidebar extends Component {
    state = {
        isExisting: true,
        // formOptions: [
        //     { title: "Existing properties", className: "existing-forms" },
        //     { title: "Create new", className: "new-form" }
        // ],
        activeTab: 0
    };

    // switchTab = (index) => {
    //     this.setState({ activeTab: index })
    //     // 
    //     // this.setState(prev => {
    //     //     if(index == 0) {
    //     //         prev.isExisting = true;
    //     //     }
    //     //     if(index == 1){
    //     //         prev.isExisting = false;

    //     //     }
    //     //     prev.formOptions.map(opt => opt.isActive = !opt.isActive)
    //     //         return {formOptions:prev.formOptions, isExisting:prev.isExisting}
    //     // })
    // }
    render() {

        const { formItems, hideHandlers, showhandlers } = this.props;
        const { isExisting, formOptions } = this.state;
        return (
            <div className="form-column formItems-container scroll-no-scrollbar h-100 bg-gray-6">
                {/* <div className="form-status">
                    {formOptions.map((opt, index) => {
                        const { className, title,  } = opt;
                        return (
                            <div
                                key={index}
                                onClick={() => this.switchTab(index)}
                                className={"form-title " + className}
                                style={{
                                    backgroundColor:
                                        index == this.state.activeTab
                                            ? "#fff"
                                            : "rgb(245, 240, 240)"
                                }}
                            >
                                {title}
                            </div>
                        );
                    })}
                </div> */}
                {/* {isExisting ? ( */}
                <ExistingForms
                    hideHandlers={hideHandlers}
                    showhandlers={showhandlers}
                    formItems={formItems}
                    onSave={this.props.onSave}
                    lastStage={this.props.lastStage}
                    lastStagePage={this.props.lastStagePage}
                    saveTitle={this.props.saveTitle}
                    page={this.props.page}
                    language={this.props.language}
                />
                {/* ) : null} */}
            </div>
        );
    }
}

export default FormBuilderSidebar;
